<template>
  <div class="text-center py-8">
    <v-icon size="56" color="silver-chalice">{{ icon }}</v-icon>
    <div class="text-subtitle-1 font-weight-medium mt-3">{{ title }}</div>
    <div v-if="subtitle" class="text-body-2 grey--text mt-1">{{ subtitle }}</div>
    <div v-if="$slots.default" class="mt-4">
      <slot/>
    </div>
  </div>
</template>

<script>
  // Presentational empty state for v-data-table's #no-data slot: icon + title + optional
  // subtitle, with an optional action (e.g. a "Reset filters" button) via the default slot.
  export default {
    name: 'EmptyState',

    props: {
      icon: {
        type: String,
        default: 'mdi-inbox-outline',
      },
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: '',
      },
    },
  };
</script>
